module.exports = __webpack_public_path__ + "img/reply.ad2e6104.svg";